module.exports = __webpack_public_path__ + "img/UDIzhuisu.2175130b.png";